import React, { useState } from "react";
import { serverUrl, alipayOAuthDisabled } from "../_constants";
import alipayLogo from "../img/alipay.png";

function AlipayOAuthButton({ onClick }) {
  const [alipayCheckboxChecked, setAlipayCheckboxChecked] = useState(false);

  if (alipayOAuthDisabled) {
    return null;
  }

  const handleClick = (event) => {
    if (!alipayCheckboxChecked) {
      event.preventDefault();
      return;
    }
    if (onClick) {
      event.preventDefault();
      onClick(event);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginLeft: 40 }}>
      <input
        type="checkbox"
        id="alipay-oauth-checkbox"
        checked={alipayCheckboxChecked}
        onChange={(event) => setAlipayCheckboxChecked(event.target.checked)}
        className="alipay-oauth-checkbox"
        style={{ position: "absolute", opacity: 0, cursor: "pointer" }}
      />
      <label htmlFor="alipay-oauth-checkbox" className="alipay-oauth-label" style={{ display: "flex", alignItems: "center", cursor: "pointer", marginBottom: 10 }}>
        <span className="alipay-oauth-text" style={{ fontSize: 14, display: "flex", alignItems: "center" }}>
          我同意
          <a href="https://naviconf.cn/agreements" target="_blank" style={{ marginLeft: 4, color: "#007bff", textDecoration: "underline" }}>
            条款
          </a>
        </span>
      </label>
      <a
        href={serverUrl + "auth/alipay"}
        onClick={handleClick}
        style={{
          opacity: alipayCheckboxChecked ? 1 : 0.5,
          cursor: alipayCheckboxChecked ? "pointer" : "not-allowed",
        }}
      >
        <img
          src={alipayLogo}
          style={{
            filter: alipayCheckboxChecked ? "none" : "brightness(0.5)",
          }}
        />
      </a>
    </div>
  );
}

export { AlipayOAuthButton };
